import {
  useIsSpecialCardSet,
  useIsSupportedCardSet,
  useSetBackground,
} from '@sorare/core/src/set';

type Props = {
  set: Nullable<string>;
};

export const CollectionSetBackground = ({ set }: Props) => {
  const getSetBackground = useSetBackground();
  const isSpecialCardSet = useIsSpecialCardSet();
  const isSupportedCardSet = useIsSupportedCardSet();

  if (!isSupportedCardSet(set)) {
    return null;
  }
  if (isSpecialCardSet(set)) {
    return <div style={getSetBackground(set)} />;
  }
  return null;
};
